import { ChildById } from "../ComponentRenderer";
import { ComponentProps } from "../registry";
import { readChildren, useBound } from "../helpers";
import { BoundValue } from "../../types";

export function Column({ fields, scope }: ComponentProps) {
  const alignment = useBound<string>(fields.alignment as BoundValue, scope);
  const children = readChildren(fields);

  return (
    <div className={`a2-col${alignment ? ` align-${alignment}` : ""}`}>
      {children && "explicitList" in children
        ? children.explicitList.map((id) => <ChildById key={id} id={id} scope={scope} />)
        : null}
    </div>
  );
}
